module.exports = __webpack_public_path__ + "media/1.0e7e9222.mp4";